import React from 'react';

import Form from '../../../../vendor/react-validation/components/form';
import ValidationButton from '../../../Forms/Components/ValidationButton';
import Checkbox from '../../../Forms/Components/Checkbox';
import getFormValues from '../../../Forms/getFormValues';
import {required} from '../../../Forms/Validation/rules';
import InfoBox from '../../../UI/InfoBox';

class BaseForm extends React.Component {
    constructor() {
        super();
        this.accordionContent = React.createRef();
    }

    formSubmit() {
        const formValues = getFormValues(this.form);
        this.props.onSubmit(formValues);
    }

    componentDidMount () {
        const accordionContent = this.accordionContent.current;

        if (this.props.isOpen && accordionContent) {
            setTimeout(() => {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
            }, 100);
        }
    }

    

    render() {

        const termsSection = (
            <div>
                <div className="extend-student-insurance-teaser__content__section">
                    <Checkbox
                        type="checkbox"
                        id={"IsFullyAbleToWork" + this.props.formId}
                        name={"IsFullyAbleToWork" + this.props.formId}
                        smallLabel
                        labelAsInline
                        value={true}
                        validations={[
                            required
                        ]}
                        data-validation-error-message="Du måste vara studieför"
                        displayname={"Jag intygar att jag är fullt studieför. Se definition i förköpsinformationen."}
                    >
                        <InfoBox isFixed top={5} marginTop={5} fontSize={14}>
                            För att försäkringen ska gälla så måste du vara fullt studieför vid anslutningen och 3 månader innan. Det innebär att du kan studera utan begränsningar. Du är inte fullt studieför om du tar emot eller har rätt till ersättning som har samband med egen sjukdom, olycksfall och/eller funktionsnedsättning eller om du har vilande sådan ersättning.
                        </InfoBox>
                    </Checkbox>
                </div>
                <div className="extend-student-insurance-teaser__content__section">
                    <Checkbox
                        type="checkbox"
                        id={"PurchaseTermsApproved" + this.props.formId}
                        name={"PurchaseTermsApproved" + this.props.formId}
                        smallLabel
                        value={true}
                        validations={[
                            required
                        ]}
                        data-validation-error-message="Du måste godkänna villkoren"
                        displayname={(<span>Jag bekräftar att jag har tagit del av förköpsinformation och att försäkringen som den beskrivs i <a href={this.props.termsAndConditionsUrl}>förköpsinformationen</a> motsvarar mina krav och behov</span>)}
                    />
                </div>
                <div className="extend-student-insurance-teaser__content__section extend-student-insurance-teaser__content__section--actions">
                    <ValidationButton noIcon>Förläng nu</ValidationButton>
                </div>
            </div>
        )

        if (this.props.showHeader) {
            return (
                <Form
                    ref={el => { this.form = el; }}
                    onSubmit={(ev) => { ev.preventDefault(); this.formSubmit(); }}
                >
                    <div ref={this.props.domRef} className="extend-student-insurance-teaser__content__accordion" data-lf-accordion-open={this.props.isOpen} >
                        <a data-lf-accordion href="#" onClick={ e => { e.preventDefault(); this.props.onFormHeaderClick() } }>
                            <h4>{ this.props.header }</h4>
                        </a>
                        <div data-lf-accordion-body ref={this.accordionContent}>
                            <div className="extend-student-insurance-teaser__content__section">
                                <p>{ this.props.body }</p>
                            </div>
                            { this.props.children }
                            { termsSection }
                        </div>
                    </div>
                </Form>
            );
        }

        return (
                <Form
                    ref={el => { this.form = el; }}
                    onSubmit={(ev) => { ev.preventDefault(); this.formSubmit(); }}
                >
                    { this.props.children }
                    { termsSection }
                </Form>
            );
    }
}

// state

export default BaseForm;